export const SIGN_PROCESS_SLUG = `signprocess`;
export const SIGN_PROCESS_FULL_PATH = `/manage/${SIGN_PROCESS_SLUG}`;
export const SIGN_PROCESS_LONG_OP_SLUG = `signprocesslongop`;
export const SIGN_PROCESS_LONG_OP_FULL_PATH = `/manage/${SIGN_PROCESS_LONG_OP_SLUG}`;
export const SIGN_PROCESS_LONG_OP_SUBMITTED_SLUG = `signerlongopsubmitted`;
export const SIGN_PROCESS_LONG_OP_DOWNLOAD_FILE_ERROR = `signerlongopdownloadfileerror`;
export const SEARCH_SIGN_PROCESS_LONG_OP_SLUG = `searchsignprocesslongop`;
export const SEARCH_SIGN_PROCESS_LONG_OP_SLUG_FULL_PATH = `/manage/${SEARCH_SIGN_PROCESS_LONG_OP_SLUG}`;
export const SIGNER_LONG_OP_SLUG = `signerlongop`;
export const SIGN_PROCESS_COMPLETED = `signprocesscompleted`;
